// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pd-1";
export var messageSideRight = "_pd-2";
export var orderLookupBubbleContainer = "_pd-0";
export var submitButton = "_pd-3";